export const environment = import.meta.env.VITE_ENV as string;
export const subscriptionKey = import.meta.env.VITE_AZURE_SUBSCRIPTION_KEY as string;
export const region = import.meta.env.VITE_AZURE_REGION as string;
export const apiUrl = import.meta.env.VITE_API_URL as string;
export const baseApiUrl = import.meta.env.VITE_API_BASE_URL as string;

export const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN as string;
export const auth0ClientId = import.meta.env.VITE_AUTH0_CLIENT_ID as string;
export const auth0Audience = import.meta.env.VITE_AUTH0_AUDIENCE as string;

export const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string;
export const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN;
export const ckeditorLicenseKey = import.meta.env.VITE_CKEDITOR_LICENSE_KEY ?? 'GPL';

export const isDev = import.meta.env.VITE_ENV !== 'prod';
export const isProdOrQA = import.meta.env.VITE_ENV === 'prod' || import.meta.env.VITE_ENV === 'qa';
export const isDatadogEnabled = (import.meta.env.VITE_DD_ENABLED as string) === 'true';
export const datadogClientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN as string;
export const datadogApplicationId = import.meta.env.VITE_DATADOG_APPLICATION_ID as string;
export { APP_VERSION as appVersion } from 'generated/version';
